import { LoopType } from '../../enums/loop/loop-type';
import { ResultType } from '../../enums/loop/result-type';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a Loop task.
 * Supports two loop modes: LoopRecords (iterates over all flow records) and
 * LoopArrayItems (iterates over elements of an array field within each record).
 */
export class LoopConfig extends DestinationTaskConfigBase {
	/** Loop mode. LoopRecords=0 (one iteration per flow record), LoopArrayItems=1 (one iteration per array element). @default LoopType.LoopRecords */
	loopType: LoopType = LoopType.LoopRecords;
	/**
	 * How iteration outputs are collected.
	 * ResultPerRecord=0 (one record per iteration output),
	 * JoinRecordsIntoASingleResult=1 (all outputs merged into one record),
	 * ResultPerArrayItem=2 (one record per array item output).
	 * ReplaceInPlace=3 (replaces the original item with the output of the loop body).,
	 * Defaults to ResultPerRecord for LoopRecords, ResultPerArrayItem for LoopArrayItems.
	 */
	resultType: ResultType = ResultType.ResultPerRecord;
	/** Dot-notation path to the array field to iterate over. Required when loopType=LoopArrayItems. @default '' */
	arrayFieldKey = '';
	/** TaskMapping  ID that links to the first task inside the loop body. The loop executes this task once per iteration. @default '' */
	loopDestinationID = '';

	constructor(init?: Partial<LoopConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
			if (init.resultType === undefined) {
				if (init.loopType === LoopType.LoopRecords) {
					init.resultType = ResultType.ResultPerRecord;
				} else {
					init.resultType = ResultType.ResultPerArrayItem;
				}
			}
		}
	}
}
